module.exports = __webpack_public_path__ + "static/media/blogLogo.659e8dc3.png";